import { connect, MapStateToProps } from 'react-redux'
import { Props } from './ComparisonWrapper'
import comparisonCarlineStructureSelector
    from '../../redux/selectors/comparison/comparisonCarlineStructureSelector'
import {
    fetchCodeComparisonResultData,
    fetchModelComparisonResultData,
    resetComparisonResultData,
} from '../../redux/actions/app/comparisonResultData.actions'
import comparisonCarlineResultDataSelector
    from '../../redux/selectors/comparison/comparisonCarlineResultDataSelector'
import selectedCarlineIdSelector from '../../redux/selectors/carlines/selectedCarlineIdSelector'
import configuredModelIdSelector from '../../redux/selectors/models/configuredModelIdSelector'
import vehicleCodeSelector from '../../redux/selectors/vehicleCodeSelector'
import comparisonPageIsLoadingSelector from '../../redux/selectors/is-loading/comparisonPageIsLoadingSelector'
import comparisonDataSelector from '../../redux/selectors/comparison/comparisonDataSelector'
import { setComparisonData } from '../../redux/actions/app/comparisonData.actions'
import viewPropertiesSelector from '../../redux/selectors/viewPropertiesSelector'
import isCompassEnabledSelector from '../../redux/selectors/feature-scope/isCompassEnabledSelector'
import { fetchComparisonCarlineStructure } from '../../redux/actions/app/comparisonCarlineStructure.actions'

type StateProps = Pick<
    Props,
    | 'carlineStructure'
    | 'resultData'
    | 'comparisonData'
    | 'selectedCarineId'
    | 'selectedModelId'
    | 'selectedVehicleCode'
    | 'isLoading'
    | 'isCompassEnabled'
    | 'viewProperties'
>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    carlineStructure: comparisonCarlineStructureSelector(state),
    resultData: comparisonCarlineResultDataSelector(state),
    comparisonData: comparisonDataSelector(state),
    selectedCarineId: selectedCarlineIdSelector(state),
    selectedModelId: configuredModelIdSelector(state),
    selectedVehicleCode: vehicleCodeSelector(state),
    isLoading: comparisonPageIsLoadingSelector(state),
    isCompassEnabled: isCompassEnabledSelector(state),
    viewProperties: viewPropertiesSelector(state),
})

type DispatchProps = Pick<Props, 'getModelComparisonResult' | 'getCodeComparisonResult' | 'resetComparisonResultData' | 'setComparisonData' | 'getComparisonCarlineStructure'>

const mapDispatchToProps: DispatchProps = {
    getModelComparisonResult: fetchModelComparisonResultData,
    getCodeComparisonResult: fetchCodeComparisonResultData,
    resetComparisonResultData: resetComparisonResultData,
    setComparisonData: setComparisonData,
    getComparisonCarlineStructure: fetchComparisonCarlineStructure,
}

export default connect(mapStateToProps, mapDispatchToProps)
